// Opacity only: keep drag-and-drop geometry and the sticky preview unchanged.
export const HIGHLIGHT_FADE_IN_SX = {
  animation: 'benefitsHighlightFadeIn 180ms ease-out',
  '@keyframes benefitsHighlightFadeIn': {
    from: { opacity: 0 },
    to: { opacity: 1 },
  },
  '@media (prefers-reduced-motion: reduce)': {
    animation: 'none',
  },
};
